import React from "react";
import { Collapse } from "antd";
import PanelChild from "./PanelChild";

import { CaretRightOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { layerFetch, selectLicenseList } from "../../../api/redux";
const { Panel } = Collapse;

export default (props) => {
  const dispatch = useDispatch();
  const state = useSelector(selectLicenseList);
  React.useEffect(() => {
    const token = JSON.parse(localStorage.getItem("userInfo"))?.token;
    dispatch(layerFetch(token));
  }, []);
  let layers = state.layers;
  return (
    <div className="d-flex flex-column">
      <Collapse
        bordered={false}
        defaultActiveKey={["1"]}
        // expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 180} />}
        className="site-collapse-custom-collapse"
        style={{ direction: "rtl" }}
      >
        {layers &&
          Object.keys(layers).map((key, index) => {
            return (
              <Panel
                header={layers[key].title}
                key={index}
                className="site-collapse-custom-panel"
              >
                {layers[key].children.map((child) => {
                  return <PanelChild text={child.title} data={child} />;
                })}
              </Panel>
            );
          })}
      </Collapse>
    </div>
  );
};
